import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Meta, Data } from 'utils/types';

import c from '../utils/constants';

interface Result {
  data: Data;
  meta: Meta;
}

export default function useGetField(id: string) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useQuery<Data, ApiError>({
    queryKey: [c.FIELDS, id],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: `api/v1/data/${id}`,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/data/${id}`,
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
  });
}
